/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow

import React from 'react';
import { Col, Row } from 'reactstrap';
import { componentQuestionsByName } from '@hbrisk/sp3-risk-model-support/models/componentQuestions/index.js';
import { Field, FormGroup, Label } from '#components/pages/Models/Model/support/form/index.js';
import getImmediateDescendants from '#support/models/componentQuestions/getImmediateDescendants.js';

type Props = {|
  fieldsByName: Object,
  form: string,
  name: string,
|};

const getRenderFields = (form, fieldsByName) => {
  const renderFields = (name: string) => {
    const { isRoot } = componentQuestionsByName[name];
    const immediateDescendants = getImmediateDescendants(name);
    return (
      <FormGroup key={name} form={form} fields={[name]} className={isRoot ? '' : 'pl-5 mt-2'}>
        <Label field={fieldsByName[name]} />
        <Row>
          <Col lg="6">
            <Field field={fieldsByName[name]} excludeLabel />
          </Col>
        </Row>
        {immediateDescendants.map(n => renderFields(n))}
      </FormGroup>
    );
  };
  return renderFields;
};

const ComponentQuestion = ({ fieldsByName, form, name }: Props): Function =>
  getRenderFields(form, fieldsByName)(name);

export default ComponentQuestion;
